import { z } from 'zod'
import { UTCMillisecondsSchema } from '../time'
import { CardSendIdSchema } from '../ids'
import { AuditPropsSchema } from '../common'
import { UserCardSchema } from './userCard'
import { CompanyCardSchema, DecoratedCompanyCardSchema } from './companyCard'
import { CardEntityIdSchema, CardResidentSchema } from './common'

export const CardSchema = z.discriminatedUnion('entityType', [CompanyCardSchema, UserCardSchema])
export type CardData = z.infer<typeof CardSchema>

export const DecoratedCardSchema = z.discriminatedUnion('entityType', [DecoratedCompanyCardSchema, UserCardSchema])
export type DecoratedCard = z.infer<typeof DecoratedCardSchema>

export const CardActivitySchema = z.object({
  ...AuditPropsSchema.shape,
  recordType: z.enum(['view', 'save', 'sent']),
  entityId: CardEntityIdSchema,
  sendId: CardSendIdSchema.optional(),
  activityAt: UTCMillisecondsSchema,
  resident: CardResidentSchema.optional(),
})
export type CardActivity = z.infer<typeof CardActivitySchema>
